import {
    Component,
    OnInit,
    Input,
    Injector,
    ViewChild,
    ElementRef,
    Output,
    EventEmitter,
} from "@angular/core";
import { CorreiosService } from "@app/shared/common/correios/correios.service";
import { AppComponentBase } from "@shared/common/app-component-base";
import { NgForm } from "@angular/forms";
import { AppUserAddressDtoType } from "@shared/AppEnums";

@Component({
    moduleId: module.id,
    selector: "select-language",
    templateUrl: "./select-language.component.html",
    exportAs: "selectLanguageComponent",
})
export class SelectLanguageComponent
    extends AppComponentBase
    implements OnInit
{
    @ViewChild("descriptionLanguageNameCombobox")
    descriptionLanguageNameCombobox: ElementRef;

    @Input("languages") languages: abp.localization.ILanguageInfo[] = [];
    @Input("languageDto") descriptionLanguageName;
    @Output() changeLanguage: EventEmitter<number> = new EventEmitter();

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.loadLanguages();
        if (!this.descriptionLanguageName)
            this.descriptionLanguageName =
                this.localization.currentLanguage.name;
    }

    loadLanguages() {
        this.languages = abp.localization.languages;

        setTimeout(() => {
            $(this.descriptionLanguageNameCombobox.nativeElement).selectpicker(
                "refresh"
            );
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/localization/select-language/select-language.component.ts